import type { Slot } from '../types'

interface SlotProgressProps {
  slots: Slot[]
}

export function SlotProgress({ slots }: SlotProgressProps) {
  const requiredSlots = slots.filter((s) => s.min > 0)
  if (requiredSlots.length === 0) return null

  const completed = requiredSlots.filter((s) => s.uploads.length >= s.min).length
  const total = requiredSlots.length
  const allDone = completed === total
  const percent = total > 0 ? (completed / total) * 100 : 0

  return (
    <div className="mb-6">
      <div className="mb-1.5 flex items-baseline justify-between">
        <span className="clara-small text-[var(--ink-3)]">
          {allDone ? 'All evidence captured' : `${completed} of ${total} items complete`}
        </span>
      </div>
      <div className="h-1 overflow-hidden rounded-full bg-[var(--rule-light)]">
        <div
          className={`h-full rounded-full transition-all duration-500 ease-out ${
            allDone ? 'bg-[var(--gold)]' : 'bg-[var(--green)]'
          }`}
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  )
}
